import React from 'react';
import './ConsultaImoveis.css';

// Delphi UConsultaImovel.pas: clicando no label/cor de uma categoria,
// o grid exibe apenas os lotes daquele status (BitBtn3Click linhas 1100-1189
// atualiza os contadores, e cada label tem handler de clique associado).
var ITENS_LEGENDA = [
  { key: 'bloqueado', label: 'Bloqueado', cor: '#000000', texto: '#ffffff' },
  { key: 'vendido', label: 'Vendido', cor: '#FF0000', texto: '#ffffff' },
  { key: 'carteira', label: 'Carteira', cor: '#800000', texto: '#ffffff' },
  { key: 'reservado', label: 'Reservado', cor: '#FF8000', texto: '#ffffff' },
  { key: 'pre_venda', label: 'Pré-Venda', cor: '#0000FF', texto: '#ffffff' },
  { key: 'alugado', label: 'Alugado', cor: '#00FF80', texto: '#000000' },
  { key: 'disponivel', label: 'Disponível', cor: '#008000', texto: '#ffffff' },
  { key: 'repasse', label: 'Repasse', cor: '#C0DCC0', texto: '#000000' },
  { key: 'proposta_rapida', label: 'Prop. Rápida', cor: '#FFFF00', texto: '#000000' },
  { key: 'sem_tabela', label: 'Disp.s/Tabela', cor: '#FF00FF', texto: '#ffffff' },
  { key: 'reserva_especial', label: 'Res. Especial', cor: '#400000', texto: '#ffffff' },
  { key: 'reserva_casa', label: 'Res. Casa', cor: '#F08080', texto: '#000000' },
];

var LegendaContadores = ({ contadores, filtrosStatus, onFiltrar }) => {
  var total = contadores ? (contadores.total || 0) : 0;
  var filtros = filtrosStatus || [];
  var temFiltro = filtros.length > 0;

  var handleClick = (key) => {
    if (!onFiltrar) return;
    var existe = filtros.indexOf(key) !== -1;
    var novo = existe ? filtros.filter((k) => k !== key) : filtros.concat([key]);
    onFiltrar(novo);
  };

  return (
    <div className="legenda-container">
      <div className="legenda-row">
        {ITENS_LEGENDA.map((item) => {
          var count = contadores ? (contadores[item.key] || 0) : 0;
          var ativo = filtros.indexOf(item.key) !== -1;
          return (
            <span
              key={item.key}
              className={`legenda-item legenda-clicavel${ativo ? ' ativo' : ''}`}
              onClick={() => handleClick(item.key)}
              title={ativo ? `Clique para remover filtro ${item.label}` : `Filtrar por ${item.label}`}
            >
              <span
                className="legenda-cor"
                style={{ backgroundColor: item.cor }}
              />
              {item.label}: <strong style={{ marginLeft: 2 }}>{count}</strong>
            </span>
          );
        })}
      </div>
      <div className="legenda-total">
        Total: {total}
        {temFiltro && (
          <button
            type="button"
            className="btn-limpar-filtro"
            onClick={() => onFiltrar && onFiltrar([])}
          >
            Limpar filtros ({filtros.length})
          </button>
        )}
      </div>
    </div>
  );
};

export default LegendaContadores;
